import React from 'react';
import Header from '../Header';
import UpgradeLicense from '../UpgradeLicense';
import upgradeLicenseImage from 'Images/ticketing-license.png';
import Wrapper from './styled';

const TicketingTools = ({ onClose }) => {
  return (
    <Wrapper>
      <Header onAccept={ onClose } onClose={ onClose } />
      <UpgradeLicense image={ upgradeLicenseImage } descriptionIntlId="upgradeLicense.ticketing.description" />
    </Wrapper>
  );
};

export default TicketingTools;
